var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSubtractTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "11px",
    viewBox: "0 0 16 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_subtract_time") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_subtract_time",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(8.000000, 5.500000) rotate(-180.000000) translate(-8.000000, -5.500000) "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    fill: "#E3EDF3",
    x: 0,
    y: 0,
    width: 16,
    height: 11,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.76493974,4.27332679 C10.0783534,3.98203567 10.0783534,3.50975946 9.76493974,3.21846834 C9.45152605,2.92717722 8.94338206,2.92717722 8.62996838,3.21846834 L6.25764257,5.42334154 C5.91411914,5.75071803 5.91411914,6.26484191 6.25764257,6.58411744 L8.62194292,8.78153166 C8.9353566,9.07282278 9.44350059,9.07282278 9.75691428,8.78153166 C10.070328,8.49024054 10.070328,8.01796433 9.75691428,7.72667321 L7.90308306,6.00369623 L9.76493974,4.27332679 Z",
    id: "Path-Copy",
    fill: "#06749F",
    fillRule: "nonzero",
    transform: "translate(8.000000, 6.000000) rotate(-270.000000) translate(-8.000000, -6.000000) "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSubtractTime);
export default __webpack_public_path__ + "static/media/icon_subtract_time.dec66253793d72d9bb666a01ae75abf4.svg";
export { ForwardRef as ReactComponent };